<template>
  <!-- <div class="cntWrap"> -->
    <div :class="['wikipediaBox', showHeader && 'newHomeBox']">
      <HeaderPage :isShow="showHeader" />
      <!-- 图册 -->
      <div v-if="articleData.imageSimpleList.length" class="swiperBox">
        <van-swipe
          :loop="false"
          :show-indicators="false"
          :width="calcWidth(330)"
        >
          <van-swipe-item
            v-for="(item, i) in articleData.imageSimpleList"
            :key="item.imageId"
          >
            <img
              :src="item.url"
              alt="图片"
              :style="{
                pointerEvents: 'none',
              }"
              @click="imagesPreview(articleData.imageSimpleList, i)"
            />
          </van-swipe-item>
        </van-swipe>
      </div>

      <!-- 标题 -->
      <h2 class="entryTitle mb_12">{{ articleData.title }}</h2>

      <!-- 义项 -->
      <div class="simpleBox mb_12">{{ articleData.shortTitle }}</div>

      <!-- 义项列表 -->
      <div
        v-if="articleData.simpleInfoDtoList.length"
        class="simpleInfoBox mb_12"
        @click="openSimpleInfoPopup"
      >
        <div class="simpleInfo">
          <div class="left">
            {{ articleData.title }}是多义词，共{{
              articleData.simpleInfoDtoList.length
            }}个义项
          </div>
          <img :src="downIcon" class="right" alt="下拉" />
        </div>
      </div>

      <!-- 正文 -->
      <div class="cntHtml entryEditor" v-html="articleData.content"></div>

      <!-- 信息项 -->
      <div
        v-if="articleData.entryInfoRelationList.length"
        class="cntHtml entryInfoBox"
      >
        <template v-if="articleData.entryInfoRelationList.length > 5">
          <div
            v-for="item in sliceInfoLen(
              articleData.entryInfoRelationList,
              'prev'
            )"
            :key="item.id"
            class="entryInfo mb_12"
          >
            <div class="left">{{ item.attributeCode }}</div>
            <div class="right">{{ item.attributeValue }}</div>
          </div>
          <Collapse>
            <div class="downInfo" v-show="openAllInfo">
              <div
                v-for="item in sliceInfoLen(articleData.entryInfoRelationList)"
                :key="item.id"
                class="entryInfo mb_12"
              >
                <div class="left">{{ item.attributeCode }}</div>
                <div class="right">{{ item.attributeValue }}</div>
              </div>
            </div>
          </Collapse>
          <div
            :class="['openInfoBtn', openAllInfo && 'activeBtn']"
            @click="openInfoFunc"
          >
            <div>{{ openAllInfo ? "收起" : "展开" }}</div>
            <img :src="downIcon" alt="下拉" />
          </div>
        </template>
        <template v-else>
          <div
            v-for="item in articleData.entryInfoRelationList"
            :key="item.id"
            class="entryInfo mb_12"
          >
            <div class="left">{{ item.attributeCode }}</div>
            <div class="right">{{ item.attributeValue }}</div>
          </div>
        </template>
      </div>

      <!-- 横向间隔 -->
      <div class="dividerBg"></div>

      <!-- 相关视频 -->
      <div v-if="articleData.relativeVideoList.length" class="videoBox">
        <div class="title mb_12">相关视频</div>
        <van-swipe
          :loop="false"
          :show-indicators="false"
          :width="calcWidth(256)"
        >
          <van-swipe-item
            v-for="item in articleData.relativeVideoList"
            :key="item.id"
          >
            <div class="videoInfo">
              <div class="posterBox">
                <img
                  class="poster"
                  :src="item.poster"
                  alt="图片"
                  :style="{
                    pointerEvents: 'none',
                  }"
                />
                <div class="bottom">
                  <img :src="playerIcon" alt="" @click="createVideo(item)" />
                  <span>{{ calcDuration(item.duration || "") }}</span>
                </div>
              </div>
              <div class="art_title">{{ item.title }}</div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <!-- 相关专题 -->
      <div v-if="articleData.relativeCatalogList.length" class="catalogBox">
        <van-swipe
          :loop="false"
          :show-indicators="false"
          :width="calcWidth(316)"
        >
          <van-swipe-item
            v-for="item in articleData.relativeCatalogList"
            :key="item.id"
          >
            <div class="catalogInfo">
              <a class="posterBox" :href="item.h5Url || item.url">
                <img class="poster" :src="item.imagePath" alt="图片" />
              </a>
              <div class="articleBox">
                <a
                  v-for="art in item.articles"
                  :key="art.id"
                  class="articleInfo"
                  :href="art.h5Url || art.url"
                >
                  <img
                    v-if="art.logo"
                    :src="art.logo"
                    class="left"
                    alt="图片"
                  />
                  <div class="right">
                    <div class="title">{{ art.title }}</div>
                    <div class="info">{{ art.info }}</div>
                  </div>
                </a>
              </div>
              <div class="lookMore">
                <a :href="item.h5Url || item.url">
                  <span>查看更多</span>
                  <img :src="downIcon" alt="" />
                </a>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <!-- 相关词条 -->
      <div v-if="articleData.relativeEntryList.length" class="relativeEntryBox">
        <div
          v-for="item in articleData.relativeEntryList"
          :key="item.id"
          @click="handleClickRelativeEntry(item.h5Url)"
          class="relativeEntryBoxInfo"
        >
          <div class="left" v-if="item.logo">
            <img :src="item.logo" alt="图片" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="info">{{ item.info }}</div>
          </div>
        </div>
      </div>

      <!-- 章节 -->
      <div
        v-if="articleData.entryDirectoryRelationList.length"
        :class="['directoryBox', showHeader && 'stickyTabs']"
      >
        <van-tabs scrollspy sticky>
          <van-tab
            v-for="item in articleData.entryDirectoryRelationList"
            :title="item.directoryName"
            :key="item.id"
          >
            <h2 class="title">{{ item.directoryName }}</h2>
            <div
              class="cntHtml entryEditor"
              v-html="item.directoryContent"
            ></div>
          </van-tab>
        </van-tabs>
      </div>

      <!-- 纠错 -->
      <div class="errorCorrectionBox">
        <div @click="openApp">
          <img :src="errorCorrection" alt="纠错" />
          <span>纠错</span>
        </div>
      </div>

      <!-- 参考资料 -->
      <div v-if="articleData.entryRefList.length" class="referenceMaterialBox">
        <div class="title">参考资料</div>
        <a
          v-for="item in articleData.entryRefList"
          :key="item.refId"
          class="content"
          :href="item.websiteUrl"
        >
          <div class="left">[{{ item.refId }}]</div>
          <div class="right">
            <span>{{ item.articleTitle }}</span>
            <span v-if="item.refDate" class="date"
              >（引用日期{{ calcDate(item.refDate || "") }}）</span
            >
          </div>
        </a>
      </div>

      <!-- 义项弹出层 -->
      <van-popup
        v-model="showSimpleInfoPopup"
        :close-on-click-overlay="false"
        position="bottom"
        :style="{ height: '50%', borderRadius: '2px 2px 0 0' }"
      >
        <div class="simpleInfoPopup">
          <div class="title">
            {{ articleData.title }}是多义词，共{{
              articleData.simpleInfoDtoList.length
            }}个义项
          </div>
          <div class="cntBox">
            <div
              v-for="item in articleData.simpleInfoDtoList"
              :key="item.articleId"
              :class="[
                'cnt',
                item.articleId == articleData.articleId && 'activeCnt',
              ]"
              @click="openNewEntry(item.url)"
            >
              <div class="left">{{ item.shortTitle }}</div>
              <div v-if="item.logo" class="right">
                <img :src="item.logo" alt="图片" />
              </div>
            </div>
          </div>
          <div class="closeBtn" @click="closePopup">关闭</div>
        </div>
      </van-popup>
  
      <!-- 词条、文献弹出层 -->
      <van-popup v-model="showPopup">
        <a
          v-if="popupData.linkEntryId"
          class="popupBox"
          :href="popupData.linkUrl"
          @click="refreshClick"
        >
          <div class="title">{{ popupData.linkTitle }}</div>
          <span class="date">{{ popupData.linkShortTitle }}</span>
        </a>
        <a
          v-else
          class="popupBox"
          :href="popupData.websiteUrl"
          @click="refreshClick"
        >
          <div class="title">{{ popupData.articleTitle }}</div>
          <span class="date"
            >[发表日期 {{ calcDate(popupData.refDate || "") }}]</span
          >
        </a>
      </van-popup>
  
      <!-- 相关视频弹层 -->
      <van-popup
        v-model="showVideoPopup"
        :style="{ width: '100%', height: '21.1rem', overflow: 'hidden' }"
        @close="closeVideoPopup"
      >
        <video
          class="videoTag"
          controls
          :src="videoData.videoInfos[0] && videoData.videoInfos[0].formats[0].url"
          disablePictureInPicture
          controlslist="nodownload noremoteplayback noplaybackrate"
          oncontextmenu="return false"
          :poster="videoData.poster"
        ></video>
      </van-popup>
    </div>

  <!-- </div> -->
</template>

<script>
import Util from "../../utils/util";
import Collapse from "../../utils/collapse";
import HeaderPage from "../../components/HeaderPage.vue";
import downIcon from "@/assets/images/audio/down_1.png";
import playerIcon from "@/assets/images/video_icon.png";
import errorCorrection from "@/assets/images/audio/errorCorrection.png";
import { mapState } from "vuex";
import { ImagePreview } from "vant";
import $ from "jquery";
import "@vant/touch-emulator";
export default {
  name: "MilitaryWikipedia",
  components: {
    HeaderPage,
    Collapse,
  },
  data() {
    return {
      showHeader: true,
      showPopup: false,
      showSimpleInfoPopup: false,
      showVideoPopup: false,
      videoData: {
        videoInfos: [],
      }, // 预览视频数据
      articleData: {
        imageSimpleList: [], // 图册
        simpleInfoDtoList: [], // 义项列表
        entryRefList: [], // 文案列表
        linkRelationList: [], // 引用词条列表
        entryInfoRelationList: [], // 信息项列表
        relativeVideoList: [], // 相关视频
        relativeCatalogList: [], // 相关专题
        relativeEntryList: [], // 相关词条
        entryDirectoryRelationList: [], //章节
      },
      popupData: {},
      downIcon,
      playerIcon,
      errorCorrection,
      collapseArr: [],
      openAllInfo: false,
      oldHeight: 0,
    };
  },
  created() {
    // jssdk初始化
    window.tem_jssdk = new window.TemplateSDK({
      switchConf: false, // 页面功能开关（点赞、评论等） 默认false：打开app；true：可以进行相关操作；json数据：控制单个功能
      imgGray: false, // 图片变灰，默认false，设置为true时全局图片置灰
      templateConf: {
        tenantId: this.mainQuery.TenantID, // 租户ID
        siteId: window.shareUlr.siteid, // 站点ID
        iosDownUrl: window.shareUlr.appDownUrl,
        androidDownUrl: window.shareUlr.appDownUrl,
        iosPKG: window.shareUlr.iosPKG,
        androidPKG: window.shareUlr.androidPKG,
        articleId: Util.getIdsObj().articleId || "", // 文稿id 491108
        articleType: "37", // 文稿类型
        articleUrl: window.location.href, // 文稿地址
        articleTitle: "", // 文稿标题
      },
    });
  },
  mounted() {
    this.showHeader = Util.showHeaderFunc();
    this.getEntryDetail();
  },
  computed: {
    ...mapState({
      mainQuery: (state) => state.mainStore.mainQuery,
    }),
    // 切割日期
    calcDate() {
      return (time) => {
        return time.split(" ")[0];
      };
    },
    // 计算轮播宽度
    calcWidth() {
      return (width) => {
        const docWidth = $("body").width();
        return docWidth * (width / 375);
      };
    },
    // 截取信息长度
    sliceInfoLen() {
      return (data, type) => {
        if (type === "prev") {
          return data.slice(0, 5);
        } else {
          return data.slice(5);
        }
      };
    },
    // 计算时长
    calcDuration() {
      return (time) => {
        let newTime = "";
        let timeArr = time.split(":");
        if (timeArr.length > 2) {
          if (timeArr[0] == "00") {
            newTime = timeArr[1] + ":" + timeArr[2];
          } else {
            const mini = parseInt(timeArr[0]) * 60 + parseInt(timeArr[1]);
            newTime = mini + ":" + timeArr[2];
          }
        } else {
          newTime = time;
        }
        return newTime;
      };
    },
  },
  methods: {
    // 初始化点击事件
    initClickFunc() {
      const _this = this;
      $(".entryEditor").on("click", "a", function(e) {
        e.preventDefault();
        _this.popupData = {};
        const targetId = $(this).attr("target");
        let data = {};
        if ($(this).attr("class") == "material_a") {
          // 参考文献
          if (_this.articleData.entryRefList.length) {
            data = _this.articleData.entryRefList.filter(
              (item) => item.refId == targetId
            )[0];
          }
        } else {
          // 引用词条
          if (_this.articleData.linkRelationList.length) {
            data = _this.articleData.linkRelationList.filter(
              (item) => item.linkEntryId == targetId
            )[0];
          }
        }
        _this.showPopup = true;
        _this.popupData = { ...data };
      });
    },
    // 打开app
    openApp() {
      // window.tem_jssdk.openApp();
    },
    // 刷新点击事件
    refreshClick() {
      this.initClickFunc();
    },
    // 获取词条详情
    getEntryDetail() {
      let params = {
        tenantId: this.mainQuery.TenantID,
        articleId: Util.getIdsObj().articleId || "",
      };
      this.$store.dispatch("getEntryDetail", params).then((res) => {
        if (res.state === 200) {
          this.articleData = { ...res.data };
          setTimeout(() => {
            this.initClickFunc();
          }, 0);
        } else {
          this.Toast("获取失败，请稍后重试");
        }
      });
    },
    // 打开义项弹层
    openSimpleInfoPopup() {
      this.showSimpleInfoPopup = true;
      setTimeout(() => {
        const height =
          $(".simpleInfoPopup").height() -
          $(".simpleInfoPopup .title")[0].offsetHeight -
          50;
        // console.log($('.simpleInfoPopup').height(), $('.simpleInfoPopup .title')[0].offsetHeight);
        $(".cntBox").css("height", `${height}px`);
      }, 0);
    },
    // 打开新词条
    openNewEntry(url) {
      location.href = url;
    },
    // 关闭弹层
    closePopup() {
      this.showSimpleInfoPopup = false;
    },
    // 展开/收起词条信息
    openInfoFunc() {
      this.openAllInfo = !this.openAllInfo;
    },
    // 视频预览
    createVideo(data) {
      this.videoData = { ...data };
      this.showVideoPopup = true;
    },
    // 关闭视频预览
    closeVideoPopup() {
      // 视频重新加载
      $(".videoTag")[0].load();
    },
    // 图片预览
    imagesPreview(images, index) {
      let list = images.map((item) => {
        return item.image;
      });
      ImagePreview({
        images: list,
        showIndex: true,
        loop: false,
        startPosition: index,
      });
    },
    // 相关词条点击跳转
    handleClickRelativeEntry(url) {
      window.open(url);
    },
  },
};
</script>
<style lang="less" scoped>
// .cntWrap {
//   height: 100vh;
//   font-family: PingFangSC-Regular, PingFang SC;
  .newHomeBox {
    margin-top: 1.2rem;
    height: auto !important;
  }
  .wikipediaBox {
    padding: 1.2rem 0;
    font-family: PingFangSC-Regular, PingFang SC;

    .mb_12 {
      margin-bottom: 1.2rem;
    }
    .swiperBox {
      overflow: hidden;
      height: 18.5rem;
      margin-bottom: 1.6rem;
      padding-left: 1.5rem;
      /deep/ .van-swipe {
        height: 100%;
        .van-swipe-item {
          // width: 33rem !important;
          padding-right: 1.6rem;
          img {
            width: 100%;
            height: 100%;
            border-radius: 0.2rem;

            object-fit: cover;
          }
        }
      }
    }
    .entryTitle {
      padding: 0 1.5rem;
      color: #222222;
      font-size: 2.4rem;
      font-weight: bold;
      line-height: 3.3rem;
    }
    .simpleBox {
      padding: 0 1.5rem;
      color: #444444;
      font-size: 1.8rem;
      line-height: 2.8rem;
    }
    .simpleInfoBox {
      padding: 0 1.5rem;
      .simpleInfo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 1rem 1rem 0.8rem;
        background: #f8f8f8;
      }
      .left {
        flex: 1;
        margin-right: 2rem;
        color: #999999;
        font-size: 1.5rem;
        font-weight: 400;
        line-height: 2.1rem;
      }
      .right {
        width: 2rem;
        height: 2rem;
      }
    }
    .cntHtml {
      margin-bottom: 1.6rem;
      padding: 0 1.5rem;
      text-align: justify;
      word-break: break-all;
      color: #222222;
      font-size: 1.8rem;
      font-weight: 400;
      line-height: 2.9rem;
    }
    .entryInfoBox {
      // padding-bottom: 1.8rem;

      .entryInfo {
        display: flex;
        justify-content: space-between;
        text-align: justify;
        .left {
          // flex: 1;
          width: 8rem;
          margin-right: 3rem;
        }
        .right {
          // width: 23.5rem;
          flex: 1;
        }
      }
      .openInfoBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1.8rem;
        cursor: pointer;
        color: #999999;
        font-size: 1.4rem;
        font-weight: 400;
        line-height: 1.6rem;
        img {
          width: 1.2rem;
          height: 1.2rem;
          margin-left: 0.4rem;
        }
      }
      .activeBtn {
        img {
          transform: rotate(180deg);
        }
      }
    }
    .dividerBg {
      width: 100%;
      height: 0.5rem;
      background: #f8f8f8;
    }
    .videoBox {
      overflow: hidden;
      margin-bottom: 1.4rem;
      padding-top: 1.6rem;
      padding-left: 1rem;
      .title {
        height: 2.4rem;
        color: #222222;
        font-size: 1.7rem;
        font-weight: bold;
        line-height: 2.4rem;
      }
      /deep/ .van-swipe {
        height: 100%;
        .van-swipe-item {
          padding: 0 1.6rem 0 0.5rem;
          .videoInfo {
            margin-bottom: 1rem;
            padding-bottom: 0.8rem;
            border-radius: 0.2rem;
            box-shadow: 0px 0.2rem 0.6rem 0px rgba(0, 0, 0, 0.07);
            .posterBox {
              position: relative;
              width: 100%;
              height: 13.5rem;
              .poster {
                width: 100%;
                height: 100%;
                border-radius: 0.2rem 0.2rem 0 0;

                object-fit: cover;
              }
              .bottom {
                position: absolute;
                bottom: 0.5rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                padding: 0 0.4rem 0 0.9rem;
                img {
                  width: 1.5rem;
                  height: 1.6rem;
                }
                span {
                  padding: 0.2rem 0.6rem;
                  color: #ffffff;
                  border-radius: 1px;
                  background: rgba(0, 0, 0, 0.5);
                  font-size: 1.2rem;
                  font-weight: 500;
                }
              }
            }
            .art_title {
              display: -webkit-box;
              overflow: hidden;
              max-height: 4.2rem;
              padding: 0.3rem 0.8rem 0rem;
              text-overflow: ellipsis;
              word-break: break-all;
              color: #222222;
              font-size: 1.5rem;
              font-weight: 400;
              line-height: 2.1rem;

              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
          }
        }
      }
    }
    .catalogBox {
      // padding-top: 1.6rem;
      overflow: hidden;
      margin-bottom: 1.4rem;
      padding: 0 1.5rem;
      /deep/ .van-swipe {
        height: 100%;
        .van-swipe__track {
          width: 100% !important;
          .van-swipe-item {
            width: 100% !important;
            padding: 0;
            .catalogInfo {
              margin-bottom: 1rem;
              padding-bottom: 1.6rem;
              border-radius: 0.2rem;
              box-shadow: 0 0 0.8rem 0 rgba(0, 0, 0, 0.1);
              .posterBox {
                display: inline-block;
                width: 100%;
                height: 12.5rem;
                .poster {
                  width: 100%;
                  height: 100%;
                  border-radius: 0.2rem 0.2rem 0 0;

                  object-fit: cover;
                }
              }
              .articleBox {
                height: 20.8rem;
                padding: 1rem 1.2rem 0;
                .articleInfo {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 1.6rem;
                  .left {
                    width: 5rem;
                    height: 5rem;
                    margin-right: 1.2rem;
                    border-radius: 0.2rem;
                    background: #848484;

                    object-fit: cover;
                  }
                  .right {
                    overflow: hidden;
                    flex: 1;
                    .title {
                      overflow: hidden;
                      height: 2.4rem;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      color: #222222;
                      font-size: 1.7rem;
                      font-weight: 400;
                      line-height: 2.4rem;
                    }
                    .info {
                      overflow: hidden;
                      height: 1.8rem;
                      margin-top: 0.8rem;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      color: #999999;
                      font-size: 1.3rem;
                      font-weight: 400;
                      line-height: 1.8rem;
                    }
                  }
                }
              }
              .lookMore {
                text-align: center;
                font-size: 1.5rem;
                font-weight: 400;
                line-height: 2.1rem;
                a {
                  color: #999999;
                  img {
                    width: 1.2rem;
                    height: 1.2rem;
                    margin-left: 0.2rem;
                    transform: rotate(-90deg);
                  }
                }
              }
            }
          }
        }
      }
    }
    .relativeEntryBox {
      margin: 0 1.5rem 2.4rem;
      padding: 1.6rem 1.2rem;
      border-radius: 0.2rem;
      background: #ffffff;
      box-shadow: 0 0 0.8rem 0 rgba(0, 0, 0, 0.1);
      .relativeEntryBoxInfo {
        display: flex;
        justify-content: space-between;

        // align-items: center;
        margin-bottom: 1.6rem;
        .left {
          width: 11.4rem;
          height: 8.4rem;
          margin-right: 0.8rem;
          border-radius: 0.2rem;
          background: #f4f5f6;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .right {
          overflow: hidden;
          flex: 1;
          .title {
            overflow: hidden;
            height: 2.4rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #222222;
            font-size: 1.7rem;
            font-weight: 500;
            line-height: 2.4rem;
          }
          .info {
            display: -webkit-box;
            overflow: hidden;
            margin-top: 0.8rem;
            text-overflow: ellipsis;
            word-break: break-all;
            color: #999999;
            font-size: 1.5rem;
            font-weight: 400;
            line-height: 2.1rem;

            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .directoryBox {
      margin-top: -0.8rem;
      /deep/ .van-tabs {
        .van-sticky--fixed {
          max-width: 640px;
          margin: 0 auto;
        }
        .van-tab {
          color: #222222;
          font-size: 1.7rem;
          // line-height: 4rem;
          // padding: 0 1.5rem;
          // overflow: inherit;
          // text-overflow: inherit;
        }
        .van-tab--active {
          color: #e41d1d;
          font-weight: 500;
        }
        .van-tabs__line {
          width: 3rem !important;
          border-radius: 0;
        }
        .van-tabs__content {
          .title {
            padding: 0 1.5rem;
            color: #222222;
            font-size: 2rem;
            font-weight: bold;
            line-height: 2.8rem;
          }
        }
      }
    }
    .stickyTabs {
      /deep/ .van-tabs {
        .van-sticky--fixed {
          margin-top: 5rem;
        }
      }
    }
    .errorCorrectionBox {
      display: flex;

      // align-items: center;
      justify-content: flex-end;
      height: 4rem;
      padding-right: 1.5rem;
      text-align: right;
      background: #f8f8f8;
      line-height: 4rem;
      div {
        display: flex;
        align-items: center;
        img {
          width: 1.6rem;
          height: 1.6rem;
          margin-right: 0.4rem;
        }
        span {
          height: 2.1rem;
          color: #505050;
          font-size: 1.5rem;
          font-weight: 400;
          line-height: 2.1rem;
        }
      }
    }
    .referenceMaterialBox {
      padding: 1.6rem 1.5rem;
      .title {
        margin-bottom: 1.6rem;
        color: #222222;
        font-size: 2rem;
        font-weight: bold;
        line-height: 2.8rem;
      }
      .content {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1.6rem;
        .left {
          flex: 1;
          height: 2.4rem;
          margin-top: 0.1rem;
          color: #999999;
          font-size: 1.7rem;
          font-weight: 500;
          line-height: 2.4rem;
        }
        .right {
          width: 30.4rem;
          margin-right: 0.5rem;
          color: #222222;
          font-size: 1.7rem;
          font-weight: 400;
          line-height: 2.4rem;
          .date {
            color: rgba(153, 153, 153, 1);
          }
        }
      }
    }
  }
  .popupBox {
    display: inline-block;
    width: 34.5rem;
    padding: 1.2rem;
    .title {
      width: 100%;
      color: #222222;
      font-size: 1.8rem;
      font-weight: 400;
      line-height: 2.5rem;
    }
    .date {
      display: inline-block;
      margin-top: 1.2rem;
      color: #999999;
      font-size: 1.5rem;
      font-weight: 400;
      line-height: 2.1rem;
    }
  }
  .simpleInfoPopup {
    overflow: hidden;
    width: 100%;
    height: 100%;
    .title {
      padding: 1.6rem 1.5rem;
      color: #999999;
      border-bottom: 1px solid #f8f8f8;
      font-size: 1.7rem;
      font-weight: 500;
      line-height: 2.4rem;
    }
    .cntBox {
      overflow-y: auto;
      margin: 0 1.5rem;
      &::-webkit-scrollbar {
        width: 0;
      }
      .cnt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2.5rem 0;
        border-bottom: 1px solid #f8f8f8;
        .left {
          flex: 1;
          color: #222222;
          font-size: 1.7rem;
          font-weight: 400;
          line-height: 2.4rem;
        }
        .right {
          width: 5rem;
          height: 5rem;
          img {
            width: 100%;
            height: 100%;
            border-radius: 0.2rem;
          }
        }
      }
      .activeCnt {
        padding: 1.6rem 0 1.2rem;
        .left {
          color: #e41d1d;
        }
      }
    }
    .closeBtn {
      padding: 1.2rem 0 1.6rem;
      text-align: center;
      color: #222222;
      border-top: 1px solid #e8e8e8;
      font-size: 1.6rem;
      font-weight: 400;
    }
  }
  .videoTag {
    width: 100%;
    height: 100%;
  }
// }
</style>
